import "./SocialStyles.css"

import React from 'react'

import { Link, NavLink } from "react-router-dom";

import { FaLinkedin, FaTwitter, FaGithub, FaInstagram } from "react-icons/fa";

import { GrMail } from "react-icons/gr";

const Social = () => {
  return (
    <div className="social">
        <h1 className="social-heading">¿Hablamos?</h1>
        <div className="social-container">
            <div className="social-icons">
                <NavLink to="https://twitter.com/ArturoCode" target={"_blank"}><FaTwitter size={35} style={{color: "#2FA9AA", marginRight: "2rem"}} /></NavLink>
                <NavLink to="https://www.instagram.com/arturocode" target={"_blank"}><FaInstagram size={35} style={{color: "#2FA9AA", marginRight: "2rem"}} /></NavLink>
                <NavLink to="https://github.com/ArturoCode" target={"_blank"}><FaGithub size={35} style={{color: "#2FA9AA", marginRight: "2rem"}} /></NavLink>
                <Link to="/contacto"><GrMail size={35} style={{color: "#2FA9AA", marginRight: "2rem"}} /></Link>
                <NavLink to="https://www.linkedin.com/in/arturo-urbanos-vara" target={"_blank"}><FaLinkedin size={35} style={{color: "#2FA9AA"}} /></NavLink>
            </div>
        </div>

        <div className="buycofee">
            <NavLink to={"https://www.buymeacoffee.com/arturocode/"} className="btn" target={"_blank"}>Invítame a un café</NavLink>
        </div>
    </div>
  )
}

export default Social